import { GameLoader } from "../loaders/GameLoader";
import { AliceIQService } from "./AliceIQService";
import { PromoCommunicationService } from "./PromoCommunicationService";


export class CommunicationService {
    promo?: PromoCommunicationService;

    private _fpService = new AliceIQService();

    constructor(
        public gameLoader: GameLoader,
        public iframe: HTMLIFrameElement
    ) {
        window.addEventListener("send-replay-open", () =>
            this.sendGameAutoplayStop("open replay")
        );
        window.addEventListener("send-lobby-open", () =>
            this.sendGameAutoplayStop("open lobby")
        );

        this.subscribe();
        this._fpService.load();
    }

    sendGameAutoplayStop(action: string): void {
        if (!this.iframe || !this.iframe.contentWindow) {
            return;
        }

        console.warn &&
            console.warn(
                `Bash action "${action}" to game -> [game:autoplay:stop]`
            );
        this.iframe.contentWindow.postMessage(
            { name: "[game:autoplay:stop]" },
            "*"
        );
    }

    subscribe(): void {
        window.addEventListener("message", (message) => {
            if (!this.iframe || !message.data || !this.iframe.contentWindow) {
                return;
            }

            try {
                if (message.data.name === "[game::reload]") {
                    if (this.promo?.isPromoToolInited) {
                        this.promo.handleReload();
                        return;
                    }

                    window.location.reload();
                    return;
                }

                if (message.data.name === "[replay::finished]") {
                    window.dispatchEvent(
                        new CustomEvent<void>("event-replay-finished")
                    );
                    return;
                }

                if (message.data.name === "[popup.update]") {
                    console.warn(
                        `[Updated game popup state "${message.data.active}"]`
                    );
                    this.gameLoader.setActiveGamePopup(message.data.active);
                    return;
                }

                if (message.data.name === "[connect]" && message.data.userId) {
                    const userId = String(message.data.userId).trim();

                    // fixme remove it when Awards be integrated
                    this.promo?.temporaryHookInit();

                    if (!userId || userId === "-1") {
                        return;
                    }

                    this.gameLoader.setUserId(userId);
                    this.gameLoader.setSessionId(String(message.data.clientSessionId));
                    const wlidHash = message.data.wlidHash;

                    const wlCode = this.gameLoader.global?.configs?.partner;
                    const gameName = this.gameLoader.global?.configs?.gameName;

                    this._fpService.setConfig({
                        wlCode: wlCode,
                        walletId: wlidHash,
                        gameName: gameName,
                    });
                    return;
                }

                this.iframe.contentWindow.postMessage(message.data, "*");
            } catch (ep: any) {
                console.warn(`PostMessage transfer unavailable: ${ep.message}`);
            }
        });
    }
}
